import { BigMath } from "@yn/utils";

const LIMIT_PRICE_MIN = 1;
const LIMIT_PRICE_MAX = 99;
const LIMIT_PRICE_STEP = 1;

export function normalizeLimitPrice( value: number | string | undefined ): number {
    const numValue = Number( value );
    if ( Number.isNaN( numValue ) || !Number.isFinite( numValue ) || numValue <= 0 ) return 0;

    const adjustedValue = BigMath.times( Math.round( BigMath.div( numValue, LIMIT_PRICE_STEP ) ), LIMIT_PRICE_STEP, 0 );

    return Math.min( LIMIT_PRICE_MAX, Math.max( LIMIT_PRICE_MIN, adjustedValue ) );
}
